import gql from 'graphql-tag';

export default gql`
  mutation insertModeloNota(
    $titulo: String!
    $descripcion: String!
    $htmlModeloNota: String!
    $categorias: [String]
    $organismos: [String]
    $talonarios: [InputParTalonario]
    $clasificadoresEstadisticos: [String]
  ) {
    insertModeloNota(
      titulo: $titulo
      descripcion: $descripcion
      htmlModeloNota: $htmlModeloNota
      categorias: $categorias
      organismos: $organismos
      talonarios: $talonarios
      clasificadoresEstadisticos: $clasificadoresEstadisticos
    ) {
      _id
      titulo
      descripcion
      htmlModelo
      talonarios {
        talonario {
          _id
          nombre
          cantidad
        }
        organismo {
          _id
          nombre
        }
      }
      organismos {
        _id
        nombre
      }
      clasificadoresEstadisticos {
        _id
        nombre
        descripcion
      }
    }
  }
`;
